import { push } from 'react-router-redux';
import Cookie from 'js-cookie';

import {
  getLocalStorage as getStorage,
  setLocalStorage as setStorage,
} from 'shared/utils/storage';

import { authService } from '../AuthService';
import { getUser } from '../utils/http';
import { routes } from '../../routes';
import { AuthService } from '../oidc/AuthService';


export const moduleName = 'auth';
export const selectAuthFlow = process.env.NODE_ENV === 'development'
  ? 'logInDev'
  : 'logInProd';

export const LOG_IN_SUCCESS = `@${moduleName}/LOG_IN_SUCCESS`;
export const LOG_IN_ERROR = `@${moduleName}/LOG_IN_ERROR`;
export const LOG_OUT = `@${moduleName}/LOG_OUT`;
export const LOG_IN_PROGRESS = `@${moduleName}/LOG_IN_PROGRESS`;

const REPLICA = [
  'isAuthenticate',
  'role',
  'token',
  'username',
  'id',
  'user_id',
  'admin_id',
  'canWriteFolderArray',
];

const initialState = {
  isAuthenticate: false,
  isError: false,
  error: '',
  role: '',
  token: '',
  username: '',
  loading: false,
  canWriteFolderArray: [],
};

const replicatedState = Object.assign(
  initialState,
  getStorage(REPLICA),
);

const oidAuthService = new AuthService(Cookie.get('OID_REDIRECT_URI'));

export default function auth(state = replicatedState, action) {
  const { type } = action;
  switch (type) {
    case LOG_IN_SUCCESS:
      return {
        isAuthenticate: localStorage.isAuthenticate,
        isError: false,
        id: localStorage.id,
        user_id: localStorage.user_id,
        role: localStorage.role,
        abbriviationName: localStorage.abbriviationName,
        token: localStorage.token,
        username: localStorage.username,
        loading: false,
        admin_id: localStorage.admin_id,
        canWriteFolderArray: localStorage.canWriteFolderArray,
      };

    case LOG_IN_PROGRESS:
      return {
        loading: true,
      };

    case LOG_IN_ERROR:
      return {
        isAuthenticate: false,
        isError: true,
        role: '',
        token: '',
        username: '',
        loading: false,
        canWriteFolderArray: null,
      };

    case LOG_OUT:
      return {
        isAuthenticate: localStorage.isAuthenticate,
        isError: false,
        role: '',
        token: '',
        username: '',
        loading: false,
        canWriteFolderArray: null,
      };

    default:
      return state;
  }
}

export const isLoggedIn = state => state[moduleName].isAuthenticate === 'true';
export const getRole = state => state[moduleName].role;
export const isSupervisorUser = state => state[moduleName].role === 'supervisor';
export const isError = state => state[moduleName].isError;
export const isLoading = state => state[moduleName].loading;


export const redirectHome = () => (dispatch, getState) => {
  const role = getRole(getState());
  switch (role) {
    case 'admin':
      dispatch(push(routes.home));
      break;
    default:
      dispatch(push(routes.home));
      break;
  }
};

export const logInOID = credentials => (dispatch) => {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  dispatch({ type: LOG_IN_PROGRESS });
  fetch('/auth/link', {
    method: 'POST',
    headers,
    body: JSON.stringify(credentials),
  })
    .then(response => response.json())
    .then((response) => {
      if (response.status === 'ok') {
        return getUser(response.result.username)
          .then((profile) => {
            if (profile.role === 'admin' || profile.role === 'supervisor') {
              setStorage({
                id: profile.id,
                user_id: profile.user_id,
                role: profile.role,
                abbriviationName: profile.abbriviationName,
                email: profile.email,
                photo: profile.photo,
                isAuthenticate: true,
                token: response.result.token,
                username: response.result.username,
                admin_id: profile.admin_id || '',
                canWriteFolderArray: profile.canWriteFolderArray,
              });
              dispatch({ type: LOG_IN_SUCCESS });
              dispatch(redirectHome(response.result.role));
            } else {
              setStorage(initialState);
              dispatch({ type: LOG_IN_ERROR });
            }
          });
      }
      setStorage(initialState);
      return dispatch({ type: LOG_IN_ERROR });
    })
    .catch((error) => {
      throw (error);
    });
};

export const logInUser = credentials => (dispatch) => {
  authService[selectAuthFlow](credentials)
    .then((response) => {
      if (response.status.toLowerCase() === 'ok') {
        const user = response.result;
        return getUser(user.username)
          .then((profile) => {
            if (profile.role === 'admin' || profile.role === 'supervisor') {
              setStorage({
                id: profile.id,
                user_id: profile.user_id,
                role: profile.role,
                abbriviationName: profile.abbriviationName,
                email: profile.email,
                photo: profile.photo,
                isAuthenticate: true,
                token: response.result.token,
                username: response.result.username,
                admin_id: profile.admin_id || '',
                canWriteFolderArray: profile.canWriteFolderArray,
              });
              dispatch({ type: LOG_IN_SUCCESS });
              dispatch(redirectHome(response.result.role));
            } else {
              setStorage(initialState);
              dispatch({ type: LOG_IN_ERROR });
            }
          });
      }
      setStorage(initialState);
      return dispatch({ type: LOG_IN_ERROR });
    })
    .catch((error) => {
      setStorage(initialState);
      dispatch({ type: LOG_IN_ERROR });
      throw (error);
    });
};

export const logOutUser = () => (dispatch) => {
  if (window.localStorage) {
    window.localStorage.clear();
  }
  oidAuthService.clearState();
  dispatch({ type: LOG_OUT });
};



// WEBPACK FOOTER //
// ./src/Auth/redux/auth.redux.js